export const config = {
  eventGroup: 'js3_gw_index_pc_20201117',
  name: '官网首页PC端',
  identify: 'js3',
  eventTags: ['gw', 'pc']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)'
      });
    },
    loadPageIndex: function() {
      report({
        eventName: 'load_page_index',
        eventDescription: '首页加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [nameId] - 有id上报视听大赏作品id，无id为空
     */
    loadPageMedia: function(nameId) {
      report({
        eventName: 'load_page_media',
        eventDescription: '视听大赏页加载',
        eventDataValue: {
          td_pl: getDiffRouteTime(),
          name_id: nameId
        },
        types: {
          td_pl: checkTypeHOF('int'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    loadPageNews: function() {
      report({
        eventName: 'load_page_news',
        eventDescription: '公告页加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击导航的名称：攻略站、资料站、官方社区等
     */
    clickLeftNav: function(title) {
      report({
        eventName: 'click_left_nav',
        eventDescription: '点击侧边导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击类型的名称：最新、新闻、活动、公告等
     * @param {string} [kinds] - 根据点击音乐的位置：首页、公告页
     * @param {string} [nameId] - 报点击内容的id
     */
    clickNewsType: function(title, kinds, nameId) {
      report({
        eventName: 'click_news_type',
        eventDescription: '点击公告类型',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击类型的名称：官方微信、手游Q群、官方微博、制作
     */
    clickAttentionType: function(title) {
      report({
        eventName: 'click_attention_type',
        eventDescription: '点击关注类型',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 视听大赏-精彩视频、视听大赏-同人作品、视听大赏-剑侠音乐等
     * @param {string} [kinds] - 根据点击的位置：首页、视听大赏页
     */
    clickMediaType: function(title, kinds) {
      report({
        eventName: 'click_media_type',
        eventDescription: '点击大赏类型',
        eventDataValue: {
          title: title,
          kinds: kinds
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的导航名称：官网首页、江湖快讯、江湖快讯-新闻、江湖快讯-公告、江湖快讯-活动、门派介绍=门派介绍、剑侠驿站-精彩视频、剑侠驿站-同人作品、剑侠驿站-剑侠音乐、剑侠驿站-同人截图、客户服务、官方社区
     */
    clickIndexNav: function(title) {
      report({
        eventName: 'click_index_nav',
        eventDescription: '点击主导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的位置：首页主按钮、侧边悬浮窗
     */
    clickReser: function(title) {
      report({
        eventName: 'click_reser',
        eventDescription: '立即预约',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报当前门派：白麓、武当等
     */
    clickMenpai: function(title) {
      report({
        eventName: 'click_menpai',
        eventDescription: '查看门派',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 手动切换上报，上报切换时所处位置：比如1、2、3、4、5等
     */
    clickLunbotuGame: function(title) {
      report({
        eventName: 'click_lunbotu_game',
        eventDescription: '查看游戏特色轮播图',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 点击相应的按钮上报音乐名称：生死如寄等
     * @param {string} [kinds] - 根据点击音乐的位置：首页、视听大赏页
     * @param {string} [nameId] - 上报音乐id：
     */
    clickMusicName: function(title, kinds, nameId) {
      report({
        eventName: 'click_music_name',
        eventDescription: '选择音乐名称',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 上报点击页面的id
     */
    clickDifferentPage: function(nameId) {
      report({
        eventName: 'click_different_page',
        eventDescription: '点击相应页面',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    clickMoreGonglue: function() {
      report({
        eventName: 'click_more_gonglue',
        eventDescription: '更多攻略站'
      });
    },
    /**
     * @param {string} [word] - 搜索关键词
     */
    clickMoreZiliao: function(word) {
      report({
        eventName: 'click_more_ziliao',
        eventDescription: '更多资料站',
        eventDataValue: {
          word: word
        },
        types: {
          word: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的导航标题：资料站-新手指引、资料站-系统介绍、资料站-活动玩法等
     */
    clickZiliaoNav: function(title) {
      report({
        eventName: 'click_ziliao_nav',
        eventDescription: '点击首页资料站导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 根据点击投稿的位置：首页、右侧悬浮窗
     */
    clickContribution: function(kinds) {
      report({
        eventName: 'click_contribution',
        eventDescription: '点击我要投稿',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    clickMoreJianghu: function() {
      report({
        eventName: 'click_more_jianghu',
        eventDescription: '更多温情江湖'
      });
    },
    /**
     * @param {string} [title] - 上报点击的导航标题：温情江湖-游戏截图、温情江湖-线下活动、温情江湖-精美壁纸等
     * @param {string} [kinds] - 根据点击的位置：首页、温情江湖列表页
     */
    clickJianghuNav: function(title, kinds) {
      report({
        eventName: 'click_jianghu_nav',
        eventDescription: '点击温情江湖导航',
        eventDataValue: {
          title: title,
          kinds: kinds
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    clickMoreShiting: function() {
      report({
        eventName: 'click_more_shiting',
        eventDescription: '更多视听大赏'
      });
    },
    /**
     * @param {string} [title] - 上报点击的视频标题
     * @param {string} [kinds] - 根据点击音乐的位置：首页、视听大赏页
     * @param {string} [nameId] - 上报视频id：
     */
    clickVideo: function(title, kinds, nameId) {
      report({
        eventName: 'click_video',
        eventDescription: '点击视频',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的同人作品标题：
     * @param {string} [kinds] - 根据点击的位置： 首页、视听大赏页、同人作品详情页
     * @param {string} [nameId] - 上报作品id：
     */
    clickTongrenWork: function(title, kinds, nameId) {
      report({
        eventName: 'click_tongren_work',
        eventDescription: '点击同人作品',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 上报同人作品id
     */
    loadPageTongrenDetail: function(nameId) {
      report({
        eventName: 'load_page_tongren_detail',
        eventDescription: '同人作品详情页加载',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 点击的导航标题：视听盛宴、温情江湖等
     */
    loadYizhanNav: function(title) {
      report({
        eventName: 'load_yizhan_nav',
        eventDescription: '点击驿站页导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报下载的视频标题：
     */
    clickDownloadVideo: function(title) {
      report({
        eventName: 'click_download_video',
        eventDescription: '点击下载视频',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 上报分享的社区名称：朋友圈等
     * @param {string} [title] - 上报分享的视频标题：
     */
    clickShareCommunity1: function(kinds, title) {
      report({
        eventName: 'click_share_community_1',
        eventDescription: '点击分享到社区',
        eventDataValue: {
          kinds: kinds,
          title: title
        },
        types: {
          kinds: checkTypeHOF('string'),
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 上报分享的社区名称：朋友圈等
     * @param {string} [title] - 上报分享的同人作品标题
     */
    clickShareCommunity2: function(kinds, title) {
      report({
        eventName: 'click_share_community_2',
        eventDescription: '点击分享到社区',
        eventDataValue: {
          kinds: kinds,
          title: title
        },
        types: {
          kinds: checkTypeHOF('string'),
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 上报文章id
     */
    loadPageNewsDetail: function(nameId) {
      report({
        eventName: 'load_page_news_detail',
        eventDescription: '公告详情页加载',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    loadPageGonglue: function() {
      report({
        eventName: 'load_page_gonglue',
        eventDescription: '攻略页加载'
      });
    },
    /**
     * @param {string} [title] - 上报点击的导航标题：攻略站-最新、攻略站-新手、攻略站-门派、攻略站-护法等
     * @param {string} [kinds] - 根据点击的位置：首页、攻略页
     */
    clickGonglueNav: function(title, kinds) {
      report({
        eventName: 'click_gonglue_nav',
        eventDescription: '点击攻略站导航',
        eventDataValue: {
          title: title,
          kinds: kinds
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 上报攻略id
     */
    loadPageGonglueDetail: function(nameId) {
      report({
        eventName: 'load_page_gonglue_detail',
        eventDescription: '攻略详情页加载',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    loadPageZiliao: function() {
      report({
        eventName: 'load_page_ziliao',
        eventDescription: '资料页加载'
      });
    },
    /**
     * @param {string} [word] - 上报搜索的内容
     * @param {string} [status] - 事件状态 成功:success 失败：fail
     * @param {string} [evStatusReason] - 上报事件失败原因
     * @param {string} [kinds] - 根据点击按钮的位置：首页、资料页、资料搜索结果页
     */
    clickSearch1: function(word, status, evStatusReason, kinds) {
      report({
        eventName: 'click_search_1',
        eventDescription: '点击搜索游戏资料',
        eventDataValue: {
          word: word,
          status: status,
          ev_status_reason: evStatusReason,
          kinds: kinds
        },
        types: {
          word: checkTypeHOF('string'),
          status: checkTypeHOF('string'),
          ev_status_reason: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的导航标题：主线任务、快速提升等
     * @param {string} [kinds] - 根据点击按钮的位置：首页、资料页
     * @param {string} [nameId] - 上报资料文章id
     */
    clickNewPlayerNav: function(title, kinds, nameId) {
      report({
        eventName: 'click_new_player_nav',
        eventDescription: '点击新手指引导航',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [label] - 上报点击的系统所属分类：玩法系统、社交系统等
     * @param {string} [title] - 上报点击的系统标题
     * @param {string} [nameId] - 上报资料文章id：
     */
    clickSystemIntroductionNav: function(label, title, nameId) {
      report({
        eventName: 'click_system_introduction_nav',
        eventDescription: '点击系统介绍导航',
        eventDataValue: {
          label: label,
          title: title,
          name_id: nameId
        },
        types: {
          label: checkTypeHOF('string'),
          title: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [label] - 上报点击的活动所属分类：日常活动、限时活动、周历活动等
     * @param {string} [title] - 上报点击的活动标题
     * @param {string} [nameId] - 上报资料文章id
     */
    clickPlayNav: function(label, title, nameId) {
      report({
        eventName: 'click_play_nav',
        eventDescription: '点击活动玩法导航导航',
        eventDataValue: {
          label: label,
          title: title,
          name_id: nameId
        },
        types: {
          label: checkTypeHOF('string'),
          title: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击其他玩法的标题：NPC合集、练级地点、地图介绍、装备介绍等
     * @param {string} [nameId] - 上报资料文章id
     */
    clickOtherIntroductionNav: function(title, nameId) {
      report({
        eventName: 'click_other_introduction_nav',
        eventDescription: '点击资料页其他介绍导航',
        eventDataValue: {
          title: title,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    loadPageZiliaoSearch: function() {
      report({
        eventName: 'load_page_ziliao_search',
        eventDescription: '资料站搜索结果页加载'
      });
    },
    /**
     * @param {string} [nameId] - 上报介绍的资料id
     */
    loadPageZiliaoIntroductionDetail: function(nameId) {
      report({
        eventName: 'load_page_ziliao_introduction_detail',
        eventDescription: '介绍详情页加载',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的攻略标题
     * @param {string} [kinds] - 根据点击攻略的位置：首页、攻略页
     * @param {string} [nameId] - 上报攻略id
     * @param {string} [label] - 上报攻略所属模块：最新、新手、门派、护法等
     */
    clickGonglueDetail: function(title, kinds, nameId, label) {
      report({
        eventName: 'click_gonglue_detail',
        eventDescription: '点击攻略详情',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId,
          label: label
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string'),
          label: checkTypeHOF('string')
        }
      });
    },
    clickMoreNews: function() {
      report({
        eventName: 'click_more_news',
        eventDescription: '更多新闻资讯'
      });
    },
    /**
     * @param {string} [word] - 上报搜索的内容
     * @param {string} [status] - 事件状态 成功:success 失败：fail
     * @param {string} [evStatusReason] - 上报事件失败原因
     * @param {string} [kinds] - 根据点击按钮的位置：攻略页、攻略搜索结果页
     */
    clickSearch2: function(word, status, evStatusReason, kinds) {
      report({
        eventName: 'click_search_2',
        eventDescription: '点击搜索攻略',
        eventDataValue: {
          word: word,
          status: status,
          ev_status_reason: evStatusReason,
          kinds: kinds
        },
        types: {
          word: checkTypeHOF('string'),
          status: checkTypeHOF('string'),
          ev_status_reason: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    loadPageGonglueSearch: function() {
      report({
        eventName: 'load_page_gonglue_search',
        eventDescription: '攻略站搜索结果页加载'
      });
    },
    /**
     * @param {string} [kinds] - 上报搜索文章的类型：攻略搜索结果、资料搜索结果
     * @param {string} [nameId] - 上报点击搜索文章详情的id
     */
    clickSearchDetail: function(kinds, nameId) {
      report({
        eventName: 'click_search_detail',
        eventDescription: '点击搜索文章详情',
        eventDataValue: {
          kinds: kinds,
          name_id: nameId
        },
        types: {
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的图片标题
     * @param {string} [kinds] - 根据点击音乐的位置：首页、温情江湖列表页、 温情江湖-游戏截图详情页
     * @param {string} [nameId] - 上报图片id
     */
    clickGamePicture: function(title, kinds, nameId) {
      report({
        eventName: 'click_game_picture',
        eventDescription: '点击游戏截图',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的活动标题
     * @param {string} [kinds] - ev_d.kinds|根据点击音乐的位置：首页、温情江湖列表页、 温情江湖-线下活动详情页
     * @param {string} [nameId] - 上报活动id
     */
    clickOfflineActivity: function(title, kinds, nameId) {
      report({
        eventName: 'click_offline_activity',
        eventDescription: '点击线下活动',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的壁纸标题
     * @param {string} [kinds] - 根据点击音乐的位置：首页、温情江湖列表页
     * @param {string} [nameId] - 上报壁纸id
     */
    clickExquisiteWallpaper: function(title, kinds, nameId) {
      report({
        eventName: 'click_exquisite_wallpaper',
        eventDescription: '点击精美壁纸',
        eventDataValue: {
          title: title,
          kinds: kinds,
          name_id: nameId
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          name_id: checkTypeHOF('string')
        }
      });
    },
    loadPageJianghu: function() {
      report({
        eventName: 'load_page_jianghu',
        eventDescription: '温情江湖列表页加载'
      });
    },
    /**
     * @param {string} [nameId] - 上报温情江湖内容id
     */
    loadPageJianghuDetail: function(nameId) {
      report({
        eventName: 'load_page_jianghu_detail',
        eventDescription: '温情江湖详情页加载',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    clickIndexVideo: function() {
      report({
        eventName: 'click_index_video',
        eventDescription: '点击首页视频'
      });
    },
    /**
     * @param {string} [status] - 成功：success 失败：fail
     * @param {string} [evStatusReason] - 上报失败的原因
     * @param {string} [phone] - 上报预约手机号
     * @param {string} [title] - 上报选择的系统名称：苹果系统、安卓系统|
     */
    clickSubmitAppointment: function(status, evStatusReason, phone, title) {
      report({
        eventName: 'click_submit_appointment',
        eventDescription: '点击立即预约',
        eventDataValue: {
          status: status,
          ev_status_reason: evStatusReason,
          phone: phone,
          title: title
        },
        types: {
          status: checkTypeHOF('string'),
          ev_status_reason: checkTypeHOF('string'),
          phone: checkTypeHOF('string'),
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报选择的系统名称：苹果系统、安卓系统
     */
    clickChooseSystem: function(title) {
      report({
        eventName: 'click_choose_system',
        eventDescription: '选择系统',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的手机系统：苹果下载、安卓下载等
     */
    clickMoDownload: function(title) {
      report({
        eventName: 'click_mo_download',
        eventDescription: '移动端扫码下载游戏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 苹果下载、安卓下载、桌面模拟器
     */
    clickPcDownload: function(title) {
      report({
        eventName: 'click_pc_download',
        eventDescription: '点击电脑版下载游戏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickInstallInstruction: function() {
      report({
        eventName: 'click_install_instruction',
        eventDescription: '点击安装须知'
      });
    },
    loadScanCode: function() {
      report({
        eventName: 'load_scan_code',
        eventDescription: '扫描二维码追踪'
      });
    },
    clickHeadline: function() {
      report({
        eventName: 'click_headline',
        eventDescription: '点击公告头条'
      });
    },
    clickFloatWindow: function() {
      report({
        eventName: 'click_float_window',
        eventDescription: '点击KV浮窗'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
